import React, { useContext } from 'react';
import './price.css';

import { MyContext } from '../../context';

function Price() {
  const { pageData } = useContext(MyContext);

  return (
    <section className="price-body">
      <div className="container ">
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
          }}
        >
          <h2 className="price-header">{pageData?.pricePage?.header}</h2>
          <p className="price-header-p">{pageData?.pricePage?.subTitle}</p>
        </div>
        <div className="numbers-card-wrap">
          {pageData?.pricePage?.numberCardData.map((data, index) => (
            <div className="numbers-card" key={index}>
              <div className="numbers-card-header">
                <img
                  loading="lazy"
                  width="60px"
                  src={data?.image}
                  alt="roadsideAssist"
                />
                <h5 style={{ color: 'black' }}>{data.number}</h5>
              </div>
              <p
                style={{
                  color: '#112c6d',
                  textAlign: 'left',
                }}
              >
                {data.text}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Price;
